module.exports = __webpack_public_path__ + "img/domestic-2010-communication30.a827f351.jpg";